(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;

  const el = U.el;
  const esc = U.esc;
  const menuCfg = U.menuCfg;
  const saveMenuCfg = U.saveMenuCfg;
  const artImg = U.artImg;
  const ribbon = U.ribbon;
  const BK = (U.BuilderKit = U.BuilderKit || {});
  const { openBuilder, MAX_COPIES, builderState, copiesOf, totalCopies, moveCards, whyNoAdd, roomFor, bnote, addCards, cutCards, runeCut, endPick, renderCardDetail, renderCurve, renderDeckPane, renderCollection } = BK;

  const BD = { ghost: null, targets: null, zone: null, shift: false };
  let bWired = false;
  let bPressPending = false;

  function inBuilder() { return APP.screen === "builder" && APP.builder; }

  function bTile(node) {
    let e = node;
    while (e && e !== document.body) {
      if (e.classList && e.classList.contains("bbleft")) return null;
      if (e.dataset && e.dataset.card !== undefined && e.dataset.where !== undefined) return e;
      e = e.parentElement;
    }
    return null;
  }

  function bField(node) {
    const t = node && node.tagName;
    return t === "INPUT" || t === "TEXTAREA" || t === "SELECT" || (node && node.isContentEditable);
  }

  function bSecondary(ev) {
    if (ev.button === 2) return true;
    return ev.buttons !== undefined && (ev.buttons & 2) === 2;
  }

  function bApplyQuantity(cand, bulk) {
    const deck = builderState().deck;
    if (cand.where === "runes") return runeCut(deck, cand.dom, bulk);
    if (cand.where === "collection") return addCards(deck, cand.id, bulk ? Math.max(1, roomFor(deck, cand.id, "main")) : 1, "main");
    if (cand.where === "main" || cand.where === "side") {
      return cutCards(deck, cand.id, bulk ? MAX_COPIES : 1, cand.where);
    }
    return false;
  }

  function bTargets(deck, cand) {
    if (cand.where === "collection") {
      const zones = [];
      if (!whyNoAdd(deck, cand.id, "main")) zones.push("main");
      if (!whyNoAdd(deck, cand.id, "side")) zones.push("side");
      return { zones: zones, remove: false };
    }
    if (cand.where === "main") return { zones: ["side"], remove: true };
    if (cand.where === "side") return { zones: ["main"], remove: true };
    return { zones: [], remove: false };
  }

  function bApplySecondary(ev) {
    if (!inBuilder() || bField(ev.target) || BDRAG.active) return;
    const tile = bTile(ev.target);
    if (!tile) return;
    bPressPending = false;
    const b = builderState();
    if (b.pick) { bnote("Finish or cancel the pick first — Esc cancels.", "bad"); U.render(); return; }
    b.sel = tile.dataset.card;
    const cand = { id: tile.dataset.card, where: tile.dataset.where, dom: tile.dataset.dom };
    if (bApplyQuantity(cand, ev.shiftKey)) U.render();
  }

  function bWire() {
    if (bWired) return;
    const root = document.getElementById("app");
    if (!root || !root.addEventListener || !document.addEventListener) return;
    bWired = true;

    root.addEventListener("contextmenu", function (ev) {
      if (!inBuilder() || bField(ev.target) || !bTile(ev.target)) return;
      ev.preventDefault();
    });

    root.addEventListener("auxclick", function (ev) {
      if (!inBuilder() || !bSecondary(ev) || bField(ev.target)) return;
      ev.preventDefault();
      if (!bPressPending) return;
      bApplySecondary(ev);
    });

    root.addEventListener("pointerdown", function (ev) {
      if (!inBuilder()) return;
      if (ev.button !== 2 && !bSecondary(ev)) return;
      const tile = bTile(ev.target);
      if (!tile) return;
      bPressPending = true;
      BDRAG.arm({
        id: tile.dataset.card,
        where: tile.dataset.where,
        dom: tile.dataset.dom,
        draggable: tile.classList && tile.classList.contains("msct"),
        shift: ev.shiftKey,
      }, ev);
    });

    document.addEventListener("keydown", function (ev) {
      if (!inBuilder()) return;
      if (ev.key === "Shift" && BDRAG.active && !BD.shift) { BD.shift = true; bGhostQty(); return; }
      if (ev.key !== "Escape") return;
      if (BDRAG.cand) { BDRAG.cancel(); return; }
      endPick();
    });
    document.addEventListener("keyup", function (ev) {
      if (ev.key === "Shift" && BD.shift) { BD.shift = false; if (BDRAG.active) bGhostQty(); }
    });
  }

  function bCanStart(cand) {
    return !!cand.draggable && (cand.where === "collection" || cand.where === "main" || cand.where === "side");
  }

  function bMove(cand, ev) {
    BD.ghost.style.left = ev.clientX + "px";
    BD.ghost.style.top = ev.clientY + "px";

    let over = null, e = document.elementFromPoint ? document.elementFromPoint(ev.clientX, ev.clientY) : null;
    while (e) { if (e.dataset && e.dataset.zone) { over = e; break; } e = e.parentElement; }
    for (const z of bZones()) z.classList.remove("drophover", "rmhover");
    const t = BD.targets || { zones: [], remove: false };
    BD.zone = null;
    if (over && t.zones.indexOf(over.dataset.zone) >= 0) {
      over.classList.add("drophover");
      BD.zone = over.dataset.zone;
      document.body.classList.remove("bbrm");
    } else if (over && over.dataset.zone === cand.where) {
      document.body.classList.remove("bbrm");
    } else if (t.remove) {
      BD.zone = "remove";
      document.body.classList.add("bbrm");
    } else {
      document.body.classList.remove("bbrm");
    }
    bGhostQty();
  }

  function bZones() {
    return Array.prototype.slice.call(document.querySelectorAll("#builderscreen [data-zone]"));
  }

  function bActivate(cand) {
    const b = builderState();
    const c = RB.Setup.findCard(cand.id);
    BD.targets = bTargets(b.deck, cand);
    const live = BD.targets.zones.length || BD.targets.remove;

    for (const z of bZones()) {
      if (BD.targets.zones.indexOf(z.dataset.zone) >= 0) z.classList.add("dropok");
      if (BD.targets.remove && z.dataset.zone === "collection") z.classList.add("rmok");
    }

    let g = document.getElementById("bbghost");
    if (!g) {
      g = el("div", "");
      g.id = "bbghost";
      document.body.appendChild(g);
    }
    g.hidden = false;
    g.className = live ? "" : "no";
    g.innerHTML = "";
    if (c) g.appendChild(artImg(c, ""));
    const qty = el("span", "bbghostqty");
    g.appendChild(qty);
    BD.ghost = g;
    BD.shift = cand.shift;
    bGhostQty();
    if (!live) bnote(whyNoAdd(b.deck, cand.id, "main"), "bad");
    document.body.classList.add("bbdragging");
    U.render();
  }

  function bQty(cand, zone) {
    const b = builderState();
    const id = cand.id;
    if (zone === "remove") {
      const n = copiesOf(b.deck, id, cand.where);
      return BD.shift ? -n : -Math.min(1, n);
    }
    if (!zone) return 0;
    if (cand.where === "collection") return BD.shift ? Math.max(1, roomFor(b.deck, id, zone)) : 1;
    const room = Math.max(0, (zone === "side" ? BK.SIDE_MAX : RB.Decklists.DECK_SIZE) - (zone === "side" ? b.deck.side : b.deck.deck).length);
    const have = copiesOf(b.deck, id, cand.where);
    return BD.shift ? Math.min(have, room) : Math.min(1, have, room);
  }

  function bGhostQty() {
    if (!BD.ghost || !BDRAG.cand) return;
    const zone = BD.zone;
    const n = bQty(BDRAG.cand, zone);
    const q = BD.ghost.querySelector(".bbghostqty");
    BD.ghost.className = zone === "remove" ? "rm" : zone ? "" : (BD.targets && (BD.targets.zones.length || BD.targets.remove) ? "" : "no");
    if (!q) return;
    if (!zone) { q.textContent = "✕"; return; }
    if (zone === "remove") { q.textContent = String(n); return; }
    q.textContent = (BDRAG.cand.where === "collection" ? "+" : "→ ") + (BDRAG.cand.where === "collection" ? n : (zone === "side" ? "SIDE" : "MAIN"));
  }

  function bEndDrag(cand, ev, wasActive) {
    const zone = BD.zone;
    const n = wasActive ? bQty(cand, zone) : 0;

    for (const z of bZones()) z.classList.remove("dropok", "drophover", "rmok", "rmhover");
    document.body.classList.remove("bbdragging", "bbrm");
    if (BD.ghost) { BD.ghost.hidden = true; BD.ghost.innerHTML = ""; }
    BD.ghost = null; BD.targets = null; BD.zone = null; BD.shift = false;

    if (wasActive) {
      bPressPending = false;
      const b = builderState();
      if (zone && n) {
        b.sel = cand.id;
        if (zone === "remove") cutCards(b.deck, cand.id, -n, cand.where);
        else if (cand.where === "collection") addCards(b.deck, cand.id, n, zone);
        else moveCards(b.deck, cand.id, n, cand.where, zone);
      } else {
        bnote("Cancelled.", "");
      }
      U.render();
      return;
    }

    if (!ev || !bPressPending) return;
    bPressPending = false;
    if (!inBuilder()) return;
    const b = builderState();
    if (b.pick) { bnote("Finish or cancel the pick first — Esc cancels.", "bad"); U.render(); return; }
    b.sel = cand.id;
    if (bApplyQuantity(cand, ev.shiftKey)) U.render();
  }

  const BDRAG = window.UIDOM.pointerDrag({ canStart: bCanStart, start: bActivate, move: bMove, end: bEndDrag });

  function renderBuilder() {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    bWire();
    const b = builderState();
    const deck = b.deck;
    const wrap = el("div", "msui");
    wrap.id = "builderscreen";
    wrap.appendChild(el("div", "msweave"));

    const legend = deck.legend ? RB.Setup.findCard(deck.legend) : null;
    const errs = RB.Decklists.validate(deck);

    const top = el("div", "mstop");
    top.appendChild(el("div", "mshair"));
    const back = el("button", "btn bbback",
      "<svg viewBox='0 0 24 24' width='13' height='13' fill='none' stroke='currentColor' stroke-width='2.4' stroke-linecap='round' stroke-linejoin='round'><path d='M15 5 8 12l7 7'></path></svg><span>Decks</span>");
    back.onclick = function () { U.backToDecks(); };
    top.appendChild(back);

    const brand = el("div", "msbrand");
    const nameWrap = el("label", "bbnamewrap");
    nameWrap.title = "Click to rename this deck";
    const name = document.createElement("input");
    name.type = "text";
    name.className = "bbname";
    name.id = "bname";
    name.value = deck.name;
    name.placeholder = "Name this deck";
    name.setAttribute("aria-label", "Deck name");
    name.oninput = function () { deck.name = name.value; };
    name.onchange = function () { deck.name = name.value; U.render(); };
    nameWrap.appendChild(name);
    nameWrap.appendChild(el("span", "bbnamepen",
      "<svg viewBox='0 0 24 24' width='13' height='13' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><path d='M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4Z'></path><path d='M14 6l4 4'></path></svg>"));
    brand.appendChild(nameWrap);
    const ident = el("div", "bbident");
    for (const dom of (legend && legend.domains) || []) ident.appendChild(BK.runeIcon(dom));
    ident.appendChild(el("span", "mslbl", esc(legend
      ? (legend.domains || []).map(function (d) { return d.charAt(0).toUpperCase() + d.slice(1); }).join(" · ") + " — " + legend.name
      : "No legend chosen")));
    brand.appendChild(ident);
    top.appendChild(brand);

    const acts = el("div", "mstopacts");
    const exp = el("button", "btn ghost", "Export");
    exp.title = "Copy this deck as a text list or a deck code";
    exp.onclick = function () { U.exportDeckDialog(deck); };
    acts.appendChild(exp);
    const save = el("button", "btn primary", "Save deck");
    save.disabled = errs.length > 0;
    save.title = errs.length
      ? "Cannot save yet — " + errs.join(" · ")
      : "Save this deck and return to the deck list";
    save.onclick = function () {
      if (errs.length) return;
      RB.Decklists.saveCustom(deck);
      const cfg = menuCfg();
      cfg.seats[0].deck = deck.id;
      saveMenuCfg(cfg);
      U.backToDecks();
    };
    acts.appendChild(save);
    top.appendChild(acts);
    wrap.appendChild(top);

    const body = el("div", "msbody bbbody");
    const left = el("div", "bbleft");
    left.appendChild(renderCardDetail(b, deck));
    left.appendChild(renderCurve(deck));
    body.appendChild(left);
    body.appendChild(renderDeckPane(b, deck));
    body.appendChild(renderCollection(b, deck));
    wrap.appendChild(body);
    root.appendChild(wrap);
    if (BK.fitPool) BK.fitPool();
  }

  Object.assign(U, { renderBuilder: renderBuilder });
})();
